export default __webpack_public_path__ + "static/media/car-insurance.5342db60.svg";